import { render, staticRenderFns } from "./Baiao.vue?vue&type=template&id=426a9a7e&scoped=true&lang=pug&"
import script from "./Baiao.vue?vue&type=script&lang=js&"
export * from "./Baiao.vue?vue&type=script&lang=js&"
import style0 from "./Baiao.vue?vue&type=style&index=0&id=426a9a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426a9a7e",
  null
  
)

export default component.exports
import {QPage,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn})
